export interface HigherRentSettlement {
  businessType?: number | string;
  monthlyRent?: number | string;
  deductionAmount?: number | string;
  deductionRate?: number | string;
  actualMonthlyRent?: number | string;
  monthExpense?: number | string;
}

function finiteValue(value: number | string | undefined): number | undefined {
  if (value === undefined || value === null || String(value).trim() === '') return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

/** 只匹配接口实付金额，不重算租金或从含费用合计反推。 */
export function higherRentSettlementText(
  detail: HigherRentSettlement | undefined,
  formatMoney: (value: number | string) => string,
): string | undefined {
  if (String(detail?.businessType) !== '4') return undefined;
  const actualRent = finiteValue(detail?.actualMonthlyRent);
  if (actualRent === undefined) return undefined;
  const formattedRent = formatMoney(detail?.actualMonthlyRent as number | string);
  const minimumRent = finiteValue(detail?.monthlyRent);
  const deductionAmount = finiteValue(detail?.deductionAmount);
  if (minimumRent !== undefined && minimumRent === deductionAmount && actualRent === minimumRent) {
    return `保底租金与扣点金额相同，实付租金 ${formattedRent}`;
  }
  if (minimumRent !== undefined && actualRent === minimumRent) {
    return `实际按保底租金计 ${formattedRent}`;
  }
  if (deductionAmount !== undefined && actualRent === deductionAmount) {
    const rate = detail?.deductionRate;
    return `实际按${rate === undefined || rate === null || rate === '' ? '' : ` ${rate}% `}扣点计 ${formattedRent}`;
  }
  return `实付租金 ${formattedRent}`;
}
